import { AuthenticationContainerComponent } from "@/lib/authentication/container/component"
import { consumeLoading } from "@/lib/consume/loading"

export const AuthenticationContainerConsumer = consumeLoading(
  AuthenticationContainerComponent
)
